import urlParse from 'url-parse';
import { matchPath } from 'react-router';

import config from '../config';
import { getCurrentTeamUrl } from './store-service';
import { browserHistory } from './history';

export const navigate = (url, event) => {
    const urlProps = urlParse(url);

    if (
        urlProps &&
        (urlProps.hostname === `${getCurrentTeamUrl()}.${config.APP_DOMAIN}` || urlProps.hostname === config.APP_DOMAIN) &&
        url.indexOf('?pub') < 0 &&
        url.indexOf('/public/') < 0 &&
        url.indexOf('/document/') < 0
    ) {
        browserHistory.push(urlProps.pathname);
        event && event.preventDefault();
    }
}

const ROUTES_WITH_PROPS = {
    sidebarHidden: ['/psignup', '/signup', '/settings', '/:projectId/documents/:folderPath/:documentId', '/document/:documentToken', '/webex'],
    chatDisabled: ['/psignup', '/signup', '/webex'],
    appBarHidden: ['/webex'],
    withoutLoadingQuoute: ['/webex']
};

export const routeHasProp = (prop, pathname) => {
    return ROUTES_WITH_PROPS[prop].some(path => matchPath(pathname, { path }));
}
